import { v4 as uuidv4 } from "uuid"

export const services = [
  {
    id: uuidv4(),
    image: "./images/grid-1.jpg",
    title: "Certified alarm systems",
    desc:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Recusandae nesciunt facilis facere earum enim incidunt officia maxime blanditiis pariatur. Quia?",
  },
  {
    id: uuidv4(),
    image: "./images/grid-2.jpg",
    title: "Trained guard dogs",
    desc:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Recusandae nesciunt facilis facere earum enim incidunt officia maxime blanditiis pariatur. Quia?",
  },
  {
    id: uuidv4(),
    image: "./images/grid-3.jpg",
    title: "Security cameras",
    desc:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Recusandae nesciunt facilis facere earum enim incidunt officia maxime blanditiis pariatur. Quia?",
  },
]
